<template>
	<div class="deliveryRange">
		<div class="name-box">
			<div class="input-box">
				<span style="font-size:14px">店铺名称：{{shopName}}</span>
				<!-- <el-input
					v-model="shopName"
					class="name-input"
					disabled
					size="mini"
				></el-input> -->
			</div>
		</div>
		<div style="float:left; width:100px;height:90%">
			<div class="deliveryRange-box"><p> 配送范围：</p></div>
		</div>
		<div style="height:90%;margin-left:100px">
			<div class="radio-box">
				<el-radio-group  @change="typeChange" v-model="type">
					<div>
						<el-radio  :disabled='!flag' label="0">指定范围：
							<el-select size="mini" :disabled='!flag' class='reason-input' v-model="sendlvl">
								<el-option
									label="全国"
									value="1">
								</el-option>
								<el-option
									label="全区域"
									value="2">
								</el-option>
								<el-option
									label="全省"
									value="4">
								</el-option>
								<el-option
									label="全市"
									value="8">
								</el-option>
							</el-select>
						</el-radio>
					</div>

					<div style=" width:200px">
						<el-radio label="1"  :disabled='!flag'>半径范围：
							<el-input  :disabled='!flag' size="mini" class='reason-input' v-model="radius" @change='radiusChange' type="text" onkeyup="value=value.replace(/[^0-9]/g,'')" onpaste="value=value.replace(/[^0-9]/g,'')" oncontextmenu = "value=value.replace(/[^0-9]/g,'')">
							</el-input>米
						</el-radio>
					</div>
					<div>
						<el-radio label="2"  :disabled='!flag'>手动划范围：</el-radio>
					</div>
				</el-radio-group>
			</div>
			<div class="map-box">
				<w-amap :center='shopCenter'  @onInitMap="initMap"></w-amap>
			</div>
			<div class="foot-btn-box" v-if="flag" >
				<el-button type="primary" size='small' class='foot-btn' plain @click="cancel">取消</el-button>
				<el-button type="primary" size='small' class='foot-btn' plain @click="save" >保存</el-button>
			</div>
		</div>
	</div>
</template>

<script>
let _AMap = null
export default {
	name: 'deliveryRange',
	data () {
		return {
			AuthorityList: {
				'01_0004_0001': false,
				'01_0004_0002': false,
				'01_0004_0003': false,
				'01_0004_0004': false,
				'01_0004_0005': false,
				'01_0004_0006': false,
				'01_0004_0007': false,
				'01_0004_0008': false
			},
			flag: false,
			shopName: '',
			shopid: '',
			sendlvl: '1',
			type: '0',
			radius: 1000,
			reason: '',
			mapObj: null,
			shopCenter: [],
			center: [],
			pathArr: [],
			arr: [],
			circleEditor: null,
			polygonEditor: null,
			polygon: null,
			circle: null,
			pointMarker: null,
			autoInput: null,
			drive: null
		}
	},
	created () {
		this.shopName = window.sessionStorage.getItem('shopName')
		this.shopid = sessionStorage.getItem('storeid')
		console.log(sessionStorage.getItem('isAdd'))
		this.get()
		this.getAuthority('01_0001_0000_00')
		// this.getShop()
	},
	methods: {
		getAuthority (data) {
			let params = {
				pId: data
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let b = window.sessionStorage.getItem('isAdd')
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						this.AuthorityList[a[i]] = true
					}
					if (b === 'true') {
						if (this.AuthorityList['01_0001_0002_00']) {
							this.flag = true
						} else {
							this.flag = false
						}
					} else {
						if (this.AuthorityList['01_0001_0001_00']) {
							this.flag = true
						} else {
							this.flag = false
						}
					}
				}
			})
		},
		cancel () {
			history.go(0)
		},
		shop () {
			let params = {
				id: this.shopid// shopid
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/coordinate/get`,
				data: params
			}).then(res => {
				this.shopCenter = res.data.coordinate
			})
		},
		getShop () {
			let params = {
				id: this.shopid// shopid
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/coordinate/get`,
				data: params
			}).then(res => {
				this.center = res.data.coordinate
				let a = this.center[0]
				let b = this.center[1]
				this.pathArr = [[a - 0.01, b - 0.01], [a - 0.01, b + 0.01], [a + 0.01, b + 0.01], [a + 0.01, b - 0.01]]
			})
		},
		get () {
			let params = {
				id: this.shopid
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/distribution/get`,
				data: params
			}).then(res => {
				if (res.result === true) {
					this.type = res.data.sendtype + ''
					if (res.data.handrangen.length > 0) {
						this.init(res.data)
					} else {
						this.getShop()
					}
				} else {
					this.$message.error(res.msg)
				}
				this.shop()
			})
		},
		init (data) {
			this.type = data.sendtype + ''
			if (this.type === '1') {
				this.radius = data.radius
				this.center = data.center
			} else if (this.type === '2') {
				this.pathArr = data.handrangen
			} else {
				this.sendlvl = data.sendlevel + ''
			}
			// this.typeChange()
		},
		save () {
			let a = this.arr
			let b = []
			if (a.length > 0) {

			} else {
				let c = this.shopCenter[0]
				let d = this.shopCenter[1]
				a = [[c - 0.01, d - 0.01], [c - 0.01, d + 0.01], [c + 0.01, d + 0.01], [c + 0.01, d - 0.01]]
			}
			for (var i = 0; i < a.length; i++) {
				let c = a[i]
				c = c.join(',')
				b.push(c)
			}
			b = b.join(',')
			let center = this.center.join(',')
			let params = {
				id: this.shopid,
				sendtype: this.type,
				sendlvl: this.sendlvl,
				center: center,
				radius: this.radius,
				handrangen: b
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/distribution/update`,
				data: params
			}).then(res => {
				if (res.result === true) {
					this.$message.success('保存成功')
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		radiusChange () {
			if (this.type === '1') {
				if (this.radius === '') {
					this.radius = 1000
				}
				this.circleEditor.close()
				this.mapObj.remove(this.mapObj.getAllOverlays('circle'))
				this.createCircle()
			}
		},
		typeChange () {
			if (this.type === '1') {
				if (this.polygonEditor !== null) {
					this.polygonEditor.close()
					this.mapObj.remove(this.mapObj.getAllOverlays('polygon'))
				}

				this.createCircle()
			} else if (this.type === '2') {
				if (this.circleEditor !== null) {
					this.circleEditor.close()
					this.mapObj.remove(this.mapObj.getAllOverlays('circle'))
				}
				this.createPolygon()
			} else {
				if (this.polygonEditor !== null) {
					this.polygonEditor.close()
					this.mapObj.remove(this.mapObj.getAllOverlays('polygon'))
				}
				if (this.circleEditor !== null) {
					this.circleEditor.close()
					this.mapObj.remove(this.mapObj.getAllOverlays('circle'))
				}
			}
		},
		initMap ([amapObj, AMap]) {
			let _this = this
			_AMap = AMap
			this.mapObj = amapObj
			_AMap.plugin(['AMap.Autocomplete', 'AMap.ToolBar', 'AMap.Scale', 'AMap.CircleEditor', 'AMap.PolyEditor'], (res) => {
				// 在图面添加工具条控件，工具条控件集成了缩放、平移、定位等功能按钮在内的组合控件
				this.mapObj.addControl(new AMap.ToolBar())

				// 在图面添加比例尺控件，展示地图在当前层级和纬度下的比例尺
				this.mapObj.addControl(new AMap.Scale())

				// 添加标记
				this.addMarker()
				console.log(_this.type)
				if (_this.type === '1') {
					this.createCircle()
				} else if (_this.type === '2') {
					this.createPolygon()
				}
				this.mapObj.setFitView()
			})
		},
		toolBar () {
			let toolBar = new _AMap.ToolBar({
				// 简易缩放模式，默认为 false
				liteStyle: true
			})
			toolBar.setMap(this.mapObj)
		},
		addMarker () {
			let marker = new _AMap.Marker({
				icon: '//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png',
				position: this.shopCenter
			})
			marker.setMap(this.mapObj)
		},
		createCircle () {
			let _this = this
			if (this.center.length > 0) {

			} else {
				this.center = this.shopCenter
			}
			this.circle = new _AMap.Circle({
				center: this.center,
				radius: this.radius, // 半径
				borderWeight: 1,
				strokeColor: '#FF33FF',
				strokeOpacity: 1,
				strokeWeight: 1,
				fillOpacity: 0.4,
				strokeStyle: 'solid',
				strokeDasharray: [10, 10],
				// 线样式还支持 'dashed'
				fillColor: '#1791fc',
				zIndex: 50
			})
			this.mapObj.add(this.circle)

			this.circleEditor = new _AMap.CircleEditor(this.mapObj, this.circle)
			this.circleEditor.open()

			this.circleEditor.on('move', function (event) {
				_this.center = [event.lnglat.lng, event.lnglat.lat]
			})
			this.circleEditor.on('adjust', function (event) {
				_this.radius = event.radius
			})
		},
		createPolygon () {
			let _this = this
			if (this.pathArr.length > 0) {

			} else {
				let a = this.shopCenter[0]
				let b = this.shopCenter[1]
				this.pathArr = [[a - 0.01, b - 0.01], [a - 0.01, b + 0.01], [a + 0.01, b + 0.01], [a + 0.01, b - 0.01]]
			}
			this.polygon = new _AMap.Polygon({
				path: this.pathArr,
				strokeColor: '#FF33FF',
				strokeWeight: 6,
				strokeOpacity: 0.2,
				fillOpacity: 0.4,
				fillColor: '#1791fc',
				zIndex: 50
			})
			this.mapObj.add(this.polygon)
			this.polygonEditor = new _AMap.PolyEditor(this.mapObj, this.polygon)
			this.polygonEditor.open()
			this.polygonEditor.on('adjust', function (event) {
				let a = _this.pathArr
				_this.arr = []
				for (let i = 0; i < a.length; i++) {
					let b = []
					b.push(a[i].lng)
					b.push(a[i].lat)
					_this.arr.push(b)
				}
			})
			this.polygonEditor.on('addnode', function (event) {
				let a = _this.pathArr
				_this.arr = []
				for (let i = 0; i < a.length; i++) {
					let b = []
					b.push(a[i].lng)
					b.push(a[i].lat)
					_this.arr.push(b)
				}
			})
			this.polygonEditor.on('removenode', function (event) {
				let a = _this.pathArr
				_this.arr = []
				for (let i = 0; i < a.length; i++) {
					let b = []
					b.push(a[i].lng)
					b.push(a[i].lat)
					_this.arr.push(b)
				}
			})
		}
	}
}
</script>
<style lang="stylus" scoped>
.deliveryRange{
	height:calc(100% - 300px)
	min-height 400px
	.name-box{
		height :60px;
		line-height :60px;
		text-align :left;
		border-bottom 1px solid #dce2fd
		.input-box{
			margin-left :10px;
			overflow-x :hidden
			margin-bottom:10px
			.name-input {
				width: 150px;
				margin-right: 10px;
			}
			.select-box{
				width:150px;
				margin-right:10px;
			}
		}
	}
	.map-box{
		height:100%
	}
	.deliveryRange-box{
		line-height 20px
		font-size 15px
		text-align left
		padding-left 8px
		margin 20px 0
	}
	.radio-box{
		flex-direction: column;
		text-align: left;
		width:200px;
		margin-top: 20px
		.el-radio{
			margin-left :30px;
			margin-bottom :10px;
			span{
				font-size :12px
			}
		}
	}
	.foot-btn-box{
		margin-top:20px
		text-align :left
		.foot-btn{
			margin-left :50px
			width :20%

		}
	}
}

</style>
